import React from "react";
import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import "./style.css";

function TaskCard({
  name,
  description,
  status,
  subStatus,
  type,
  priority,
  deadline,
  customer,
  employee,
  vendors,
  typeFields,
  processStatus,
  taskType,
  customerSubmissionStatus,
}) {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
        overflow: "hidden",
        border: " 1px solid #f0f0f0",
      }}
    >
      {/* TOP HEADER */}
      <CardContent
        sx={{
          textAlign: "center",
          background: "var(--thm-color)",
          py: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, color: "white" }}>
          {name}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 , color:"white" }}>
          {description}
        </Typography>
      </CardContent>

      {/* DETAILS */}
      <CardContent sx={{ p: 2 }}>
        <Typography
          sx={{
            fontWeight: 600,
            color: "#444",
            mb: 3,
            mt:2,
            fontSize: "15px",
          }}
        >
          Task Information
        </Typography>

        {/* Information Items */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.4 }}>
          <InfoItem label="company Name" value={customer} />
          <InfoItem label="Assigned Employee" value={employee} />
          <InfoItem label="Status" value={status} />
          <InfoItem label="Priority" value={priority} />
          <InfoItem label="Deadline" value={deadline} />
          {taskType ? <InfoItem label="Work type" value={taskType} /> : null}
          {customerSubmissionStatus ? (
            <InfoItem label="Customer docs" value={customerSubmissionStatus} />
          ) : null}

          {/* Dynamic Type Fields */}
          {typeFields &&
            Object.entries(typeFields).map(([key, value]) => (
              <InfoItem
                key={key}
                label={key}
                value={
                  Array.isArray(value)
                    ? key === "copies"
                      ? value
                          .map((c, i) => `${c.copyNumber} - ${c.paperQuality}`)
                          .join(", ")
                      : value.join(", ")
                    : value
                }
              />
            ))}
        </Box>
      </CardContent>
    </Card>
  );
}

/* Reusable Component for Key-Value Pair */
function InfoItem({ label, value }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        background: "#f9fafc",
        border: " 1px solid #f0f0f0",
        borderRadius: 2,
        p: 1.1,
        px: 1.4,
      }}
    >
      <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#555" }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#222" }}>
        {value}
      </Typography>
    </Box>
  );
}

export default TaskCard;
